// src/components/seo/ProductJsonLd.tsx
import type { Product } from "@/types/product";

function siteUrl(): string {
  return (process.env.NEXT_PUBLIC_SITE_URL || "https://valueport.ca").replace(/\/+$/, "");
}

function toAbsoluteUrl(pathOrUrl: string): string | null {
  if (!pathOrUrl) return null;

  if (pathOrUrl.startsWith("https://") || pathOrUrl.startsWith("http://")) return pathOrUrl;

  if (pathOrUrl.startsWith("/")) return `${siteUrl()}${pathOrUrl}`;

  return null;
}

export default function ProductJsonLd({ product }: { product: Product }) {
  const images = (product.images ?? [])
    .slice()
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((img) => toAbsoluteUrl(img.url))
    .filter(Boolean) as string[];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: product.name,
    description: product.description ?? undefined,
    brand: product.brand ? { "@type": "Brand", name: product.brand } : undefined,
    image: images.length ? images : undefined,
    offers: {
      "@type": "Offer",
      priceCurrency: "CAD",
      price: product.price,
      availability: "https://schema.org/InStock",
      url: `${siteUrl()}/products/${product.slug}`,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
